const resolveAnnouncementBar = ({
  globalAnnouncementBar,
  pageAnnouncementBar,
  slug,
}) => {
  if (globalAnnouncementBar && globalAnnouncementBar.enableAnnouncementBar) {
    const isExcluded = globalAnnouncementBar.excludedPages.some(
      excludedPage => excludedPage.slug === slug
    );

    if (isExcluded) return null;

    return globalAnnouncementBar;
  }

  return pageAnnouncementBar;
};

export default resolveAnnouncementBar;
